
<script>
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import SwitchButton from '../components/SwitchButton';


export default {
    components: {
        Navbar,
        Footer,
        Loader,
        SwitchButton,
    },

    data() {
        return {
            pageID: 1,
            newDeal: {
                type: 'Voucher Code',
                category_id: 1,
                title: '',
                currentPrice: 0,
                bestPrice: 0,
                imageURL: "",
            },
            isLoading: false,
            isLoadingDomain: false,
            domainErrors: [],
            freeDelivery: false,
            freeDeliveryWithMembership: false,
            categories: [],
        };
    },

    async mounted() {
        this.categories = await this.getCategories();
    },

    methods: {

        /**
         * Make sure the domain is amongst the allowed ones.
         */
        async validateDomain() {
            this.isLoadingDomain = true;
            this.domainErrors = [];

            try {
                await window.axios.post(
                    '/api/validate',
                    { url: this.newDeal.url, type: 'Voucher Code' },
                );

                this.pageID = 2;
            } catch (error) {
                for (let err in error.response.data.errors) {
                    Vue.toasted.show(
                        error.response.data.errors[err], 
                        { duration: 6000, icon: 'error' },
                    );
                }
            } finally {
                this.isLoadingDomain = false;
            }
        },


        /**
         * Submit the deal to the portal
         */
        async postDeal() {
            this.isLoading = true;
            this.newDeal.collection_charge = 0;

            try {
                const formData = new FormData();
                Object.keys(this.newDeal).forEach((key) => formData.append(key, this.newDeal[key]));

                const response = await window.axios.post(
                    '/api/deals',
                    formData,
                    { headers: { 'Content-Type': 'multipart/form-data' } },
                );

                let title = this.newDeal.title.replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();

                this.$router.push(`/deal/${response.data.data.id}/${title}`);
            } catch (error) {
                for (let err in error.response.data.errors) {
                    Vue.toasted.show(
                        error.response.data.errors[err], 
                        { duration: 6000, icon: 'error' },
                    );
                }
            } finally {
                this.isLoading = false;
            }
        },

        setImage(event) {
            [this.newDeal.image] = event.target.files;
        },

        setCategory(itemId) {
            this.newDeal.category_id = itemId;
        },

        async getCategories() {
			const response = await window.axios.get('/api/categories/');
            return response.data.data;
		},
    },

};
</script>
<template lang="pug" src="./templates/ShareVoucher.pug"></template>
<style lang="stylus" src="./styles/ShareDeal.styl" scoped></style>
